import { render, staticRenderFns } from "./UserTransactionsItem.vue?vue&type=template&id=3276ed0a&scoped=true&"
import script from "./UserTransactionsItem.vue?vue&type=script&lang=js&"
export * from "./UserTransactionsItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3276ed0a",
  null
  
)

export default component.exports